import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class Image extends PageBlock {
  public getType(): string {
    return "Image";
  }

  protected init(): any {
    return {
      props: {
        size: "full", // default, full
        type: "grid1",
        gap: null,
        items: [],
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          size: string().required().oneOf(["default", "full"]).label("크기"),
          type: string().required().oneOf(["grid1", "grid2"]).label("레이아웃"),
          gap: string().nullable().oneOf(["sm", "md", "lg"]).label("간격"),
          items: array()
            .min(1)
            .of(
              object().shape({
                uuid: string().uuid().required().label("고유번호"),
                url: string().url().required().label("이미지 URL"),
                path: string().required().label("경로"),
              }),
            )
            .required()
            .label("이미지 목록"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
